var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAverageBlood = function SvgAverageBlood(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    baseProfile: "tiny",
    viewBox: "0 0 38.7 60",
    width: 38.7,
    height: 60,
    overflow: "visible"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3 60C8.7 60 0 51.4 0 40.9 0 27.9 11.5 9 16.4 1.5c1.3-2 4.5-2 5.8 0 5 7.5 16.5 26.4 16.5 39.4C38.7 51.4 30 60 19.3 60zm0-57.1c-.2 0-.3.1-.4.2C15.2 8.8 3 28.4 3 40.9 3 49.8 10.3 57 19.3 57s16.4-7.2 16.4-16.1c0-12.5-12.2-32.1-15.9-37.8-.1-.1-.3-.2-.5-.2zm0 49.3c-3 0-5.9-1.2-8.1-3.3s-3.3-5-3.3-8a1.54 1.54 0 0 1 1.5-1.5 1.54 1.54 0 0 1 1.5 1.5c0 2.2.9 4.3 2.5 5.9s3.7 2.4 6 2.4a1.54 1.54 0 0 1 1.5 1.5c-.1.8-.7 1.5-1.6 1.5z"
  })));
};
export default SvgAverageBlood;